// src/components/timeline/RepeatDropdown.tsx
import React, { useState } from 'react'
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { Button } from '../../styles/_app.style'
import { Item } from '../../styles/navigation.style'
import { Content } from '../navigation/navDropdowns/navDropdown.style'

export const repeatOptions = [
  'Does not recur',
  'Every weekday (Mon – Fri)',
  'Daily',
  'Weekly',
  'Monthly',
]

export const freeRepeatOptions = [
  'Every weekday (Mon – Fri)',
  'Daily',
  'Weekly',
]

interface Props {
  value: string
  onChange: (v: string) => void
  open?: boolean
  onOpenChange?: (open: boolean) => void
  triggerDataAttr?: string
  freeDropdown?: boolean
}

const RepeatDropdown: React.FC<Props> = ({
  value,
  onChange,
  open: parentOpen, // Rename props to avoid conflict
  onOpenChange: parentOnOpenChange,
  triggerDataAttr = 'slot',
  freeDropdown = false,
}) => {
  // --- Start of Fix ---

  // 1. Add local state to manage the open state internally.
  const [internalOpen, setInternalOpen] = useState(false)

  // 2. Determine if the component is being controlled by its parent.
  const isControlled = parentOpen !== undefined && parentOnOpenChange !== undefined

  // 3. Use the parent's state if controlled, otherwise use internal state.
  const open = isControlled ? parentOpen : internalOpen

  // 4. Use the parent's handler if controlled, otherwise update internal state.
  const onOpenChange = (newOpenState: boolean) => {
    if (isControlled) {
      parentOnOpenChange(newOpenState)
    } else {
      setInternalOpen(newOpenState)
    }
  }

  // --- End of Fix ---

  const optionsToRender = freeDropdown ? freeRepeatOptions : repeatOptions

  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild data-dropdown={triggerDataAttr} data-radix-dropdown-menu-trigger>
        <Button
          icon
          css={{
            minWidth: '11rem',
            marginLeft: '0.7rem',
            padding: '0 1rem',
            justifyContent: 'space-between',
            gap: '0.25rem',
            fontSize: '$md',
            '&:hover': {backgroundColor: 'transparent'}, 
            '&[data-state="open"]': { backgroundColor: 'transparent' },
            '&:active': {backgroundColor: 'transparent'},
          }}
          aria-label="Repeat interval"
          title="Repeat interval"
        >
          {value}
          {/* This now uses the correct 'open' state */}
          {open ? <FiChevronUp size={15} /> : <FiChevronDown size={15} />}
        </Button>
      </DropdownMenuTrigger>

      {/* Simplified this section as both branches were identical */}
      <Content align="start" style={{ minWidth: '11rem', fontSize: '$md' }}>
        {optionsToRender.map((opt) => (
          <Item
            key={opt}
            onSelect={() => onChange(opt)}
            style={{ width: '100%' }}
            title={opt}
            css={{ fontSize: '$md' }}
          >
            {opt}
          </Item>
        ))}
      </Content>
    </DropdownMenu>
  )
}

export default RepeatDropdown